module.exports = __webpack_public_path__ + "static/media/upload_icon.47ddd6be.svg";